import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, PropType } from "@vue/runtime-core";


export default /*#__PURE__*/_defineComponent({
  props: {
  theme: {
    type: String as PropType<"primary" | "secondary">,
    default: "primary",
  },
  size: {
    type: String as PropType<"lg" | "md">,
    default: "md",
  },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["transition-colors btn", ['btn-' + __props.theme, 'btn-' + __props.size]])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})